export default __webpack_public_path__ + "static/media/customer.44816e36.svg";